var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLp = function SvgLp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lp_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#8930C8",
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7A3FF",
    d: "M57.143 102C83.019 98.373 103 76.613 103 50.267 103 21.36 79.089-2 49.5-2S-4 21.36-4 50.267C-4 76.613 15.98 98.373 41.857 102V70.213c-2.73-.96-5.24-2.56-7.315-4.48l-3.603 3.52v17.28h-8.626v-4.266h4.258v-8.96L15.762 83.12V70.853h-5.568v-4.266h9.936V73.2l7.097-6.4 4.367-4.267c-2.402-3.413-3.93-7.68-3.93-12.266s1.528-8.854 3.93-12.267l-4.367-4.267-7.097-6.4v6.614h-9.936V29.68h5.568V17.413l10.81 9.814v-8.96h-4.259V14h8.626v17.28l3.603 3.52c3.93-3.627 9.171-5.867 14.958-5.867s11.028 2.24 14.958 5.867l3.603-3.52V14h8.626v4.267h-4.258v8.96l10.809-9.814v12.16h5.568v4.267H78.87v-6.613l-7.097 6.4-4.367 4.266c2.402 3.52 3.93 7.787 3.93 12.374a20.7 20.7 0 0 1-4.039 12.266l4.367 4.267 7.097 6.4v-6.613h10.045v4.266h-5.568v12.16l-10.81-9.706v8.96h4.259v4.266H68.06v-17.28l-3.603-3.52c-2.074 1.92-4.586 3.414-7.315 4.48z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    fill: "#8930C8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.393 60V38.91h8.712q2.369 0 4.088.926 1.73.917 2.668 2.564.936 1.638.937 3.81 0 2.184-.958 3.821-.948 1.627-2.708 2.523t-4.181.896h-5.376v-4.016h4.428q1.153 0 1.926-.402a2.76 2.76 0 0 0 1.184-1.122q.402-.731.402-1.7 0-.978-.402-1.688a2.7 2.7 0 0 0-1.184-1.112q-.783-.392-1.926-.392H55.49V60zM33.882 60V38.91h5.098v16.95h8.774V60z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lp_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff",
    rx: 50
  })))));
};
export default SvgLp;